<app-entity-page [closeClicked]="closeClicked"  detailsContentTitle=" {{(hachrazaDetails?.atarTitle || '')| translateLang | async}}" [mapContentTitle]="'iaa.app.hachraza.siteOnMap' | translate"
    [loading]="hachrazaLoading">
    <ng-template #detailsContent>
        <div class="hachraza-details-container">
            <div class="part description">
                <div class="hachraza-flex description"
                    *ngIf='hachrazaDetails && (hachrazaDetails.atarDescription | translateLang | async)!=" "'>
                    <div class="hachraza-content">
                        {{(hachrazaDetails.atarDescription | translateLang | async)?.slice(0,190)}}
                    </div>
                    <app-show-more-dialog [headerText]="'iaa.app.hachraza.siteDescription' | translate" [contentText]="(hachrazaDetails.atarDescription | translateLang | async) || ''" [direction]="'ltr'"
                        [minLength]="190"></app-show-more-dialog>
                </div>

            </div>
            <div class="table-container" role="table" [attr.aria-label]="'iaa.app.hachraza.basicSiteInformation' | translate" >
                <div class="table-row header" role="row">
                    <div class="table-cell" role="columnheader"> {{'iaa.app.hachraza.siteNumber' | translate}}</div>
                    <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.siteName' | translate}} </div>
                    <div class="table-cell" role="columnheader"> {{'iaa.app.hachraza.siteType' | translate}}</div>
                    <div class="table-cell" role="columnheader"></div>
                    <div class="table-cell" role="columnheader"></div>
                </div>
                <div class="table-row" role="row">
                    <div class="table-cell" role="cell">{{hachrazaDetails?.hachrazaId}}</div>
                    <div class="table-cell" role="cell">{{(hachrazaDetails?.atarOfficialName || '')| translateLang | async}}</div>
                    <div class="table-cell" role="cell">{{hachrazaDetails?.atarType}}</div>
                    <div class="table-cell" role="cell"></div>
                    <div class="table-cell" role="cell"></div>
                </div>
            </div>
            <details>
                <summary>
                    <div class="button">
                        <div>{{('iaa.app.hachraza.otherNames' | translate)+' '+'(' +(hachrazaDetails?.atarNames?.length || 0)+')'}}</div>
                        <div class="icons" >
                            <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }"></i>
                            <i class="pi pi-angle-down icon-clicked"></i>
                        </div>
                    </div>
                </summary>
                <div class="table-container" role="table" [attr.aria-label]="'iaa.app.ahchraza.otherNamesSite' | translate">
                    <div class="table-row header" role="row">
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.source' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.name' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.transcription' | translate}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                    <div *ngFor="let name of hachrazaDetails?.atarNames" class="table-row" role="row">
                        <div class="table-cell" role="cell">{{name.nameCode == 'H' ? ('iaa.app.hachraza.hebrew' | translate) : ('iaa.app.hachraza.arabic' | translate)}}</div>
                        <div class="table-cell" role="cell">{{name.originalName}}</div>
                        <div class="table-cell" role="cell">{{name.transliterationName}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                </div>
            </details>
            <details>
                <summary>
                    <div class="button">
                        <div>{{('iaa.app.hachraza.elementsPeriods' | translate) +' '+'('+ (hachrazaDetails?.atarPeriodsAndElements?.length || 0)+')'}}</div>
                        <div class="icons">
                            <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }"></i>
                            <i class="pi pi-angle-down icon-clicked"></i>
                        </div>
                    </div>
                </summary>
                <div class="table-container" role="table" [attr.aria-label]="'iaa.app.hachraza.elementsPeriodsOnSite' | translate">
                    <div class="table-row header" role="row">
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.element' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.periods' | translate}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                    <div *ngFor="let element of hachrazaDetails?.atarPeriodsAndElements" class="table-row" role="row">
                        <div class="table-cell" role="cell">{{element.structureName | translateLang | async}}</div>
                        <div class="table-cell" role="cell">
                            <div *ngFor="let period of element.periods">
                              {{ period | translateLang| async }} </div>
                          </div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                </div>
            </details>

            <details>
                <summary>
                    <div class="button">
                        <div>{{('iaa.app.hachraza.officialGazette' | translate)+' '+'('+(hachrazaDetails?.atarOfficialAnnouncementGazette?.length || 0)+')'}}</div>
                        <div class="icons">
                            <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }"></i>
                            <i class="pi pi-angle-down icon-clicked"></i>
                        </div>
                    </div>
                </summary>
                <div class="table-container" role="table" [attr.aria-label]="'iaa.app.hachraza.officialGazette' | translate">
                    <div class="table-row header" role="row">
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.officialGazetteType'| translate}}</div>
                        <div class="table-cell" role="columnheader"> {{'iaa.app.hachraza.officialGazetteNumber'| translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.position' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.publicationDate' | translate}} </div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                    <div *ngFor="let hachraza of hachrazaDetails?.atarOfficialAnnouncementGazette" class="table-row" role="row">
                        <div class="table-cell" role="cell">{{hachraza.announcementType}}</div>
                        <div class="table-cell link-note" (click)="goPublicationsNotebook(hachraza.announcementNo, hachraza.announcementDate)" (keydown.enter)="goPublicationsNotebook(hachraza.announcementNo,hachraza.announcementDate)" tabindex="0"
                        role="button">{{hachraza.announcementNo}}</div>
                        <div class="table-cell" role="cell">{{hachraza.announcementPage}}</div>
                        <div class="table-cell" role="cell">{{hachraza.announcementDate | date: 'dd/MM/yyyy'}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                </div>
            </details>

            <details>
                <summary>
                    <div class="button">
                        <div> {{'iaa.app.hachraza.realEstateData' | translate }} {{'iaa.app.hachraza.totalBlocksPlots' | translate: {totalBlocksPlots:hachrazaDetails?.atarTabu?.length || 0} }}</div>
                        <div class="icons">
                            <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }"></i>
                            <i class="pi pi-angle-down icon-clicked"></i>
                        </div>
                    </div>
                </summary>
                <div class="table-container" *ngIf="hachrazaDetails?.atarTabu?.length" role="table" [attr.aria-label]="'iaa.app.hachraza.realEstateData' | translate">
                    <div class="table-row header" role="row">
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.bloc' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.plot' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.settlement' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.EForecastUpdate' | translate}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                    <div *ngFor="let tabu of hachrazaDetails?.atarTabu" class="table-row" role="row">
                        <div class="table-cell" role="cell">{{tabu.tabuGush}}</div>
                        <div class="table-cell" role="cell">{{ tabu.tabuHelkaTo != null ? (tabu.tabuHelkaFrom +'-'+tabu.tabuHelkaTo) : '' }}</div>
                        <div class="table-cell" role="cell">{{tabu.tabuYishuvName}}</div>
                        <div class="table-cell" role="cell">{{tabu.tabuWarnDate | date: 'dd/MM/yyyy'}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                </div>
            </details>

            <details class="geo-location">
                <summary>
                    <div class="button">
                        <div>{{'iaa.app.hachraza.geographicLocation' | translate}} </div>
                        <div class="icons">
                            <i [ngClass]="{'pi pi-angle-left icon-default':true,'en': (currentLanguage | async)==='en' }"></i>
                            <i class="pi pi-angle-down icon-clicked"></i>
                        </div>
                    </div>
                </summary>
                <div class="table-container" role="table" [attr.aria-label]="'iaa.app.hachraza.geographicLocation' | translate">
                    <div class="table-row header" role="row">
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.southwest' | translate}} </div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.northeast' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.area' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.district' | translate}}</div>
                        <div class="table-cell" role="columnheader">{{'iaa.app.hachraza.section' | translate}}</div>
                    </div>
                    <div class="table-row" role="row">
                        <div class="table-cell" role="cell"> {{('iaa.app.hachraza.width' |translate)+' : '+ hachrazaDetails?.atarSouthWest?.gisAtarWidth}}</div>
                        <div class="table-cell" role="cell"> {{('iaa.app.hachraza.width' |translate)+' : '+hachrazaDetails?.atarNorthEast?.gisAtarWidth}}</div>
                        <div class="table-cell" role="cell">{{hachrazaDetails?.atarMerchavName}}</div>
                        <div class="table-cell" role="cell">{{hachrazaDetails?.atarMehozName}}</div>
                        <div class="table-cell" role="cell">{{hachrazaDetails?.atarSeif}}</div>
                    </div>
                    <div class="table-row" role="row">
                        <div class="table-cell" role="cell">{{('iaa.app.hachraza.length' |translate)+' : '+ hachrazaDetails?.atarSouthWest?.gisAtarHeight}}</div>
                        <div class="table-cell" role="cell">{{('iaa.app.hachraza.length' |translate)+' : '+ hachrazaDetails?.atarNorthEast?.gisAtarHeight}}</div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                        <div class="table-cell" aria-hidden="true"></div>
                    </div>
                </div>
            </details>
        </div>
    </ng-template>

    <ng-template #mapContent>
            <div class="map-container">
    <app-arcgis-map [shapes]="shapes" [mapControls]="mapControls"></app-arcgis-map>
    </div>
    </ng-template>
    <div class="info-container" style="border-bottom:none">
        <div class="info-items-container">
            <div class="info-title">{{'iaa.app.hachraza.additionalInformationSite' | translate }}</div>
            <div class="item-container">
                <img [ngClass]="{'link-icon icon-publications':true, 'en': (currentLanguage | async) === 'en'}" src="assets/atar-publications.svg" alt="Publications Icon" />
                <a class="info-item" (click)="goTo('publications')">{{'iaa.app.hachraza.publications' | translate}}</a>
            </div>
            <div class="item-container">
                <img class="link-icon" src="assets/atar-findings.svg" alt="Findings Icon" />
                <a class="info-item" (click)="goTo('maps')">{{'iaa.app.hachraza.findingsSite' | translate }}</a>
            </div>
            <div class="item-container">
                <img class="link-icon" src="assets/atar-3d-models.svg" alt="Models Icon" />
                <a class="info-item" (click)="goTo('photogrammetric_models')">{{'iaa.app.hachraza.models3D' | translate }}</a>
            </div>
            <div class="item-container">
                <img class="link-icon" src="assets/atar-licenses.svg" alt="Licenses Icon" />
                <a class="info-item" (click)="goTo('licenses')">{{'iaa.general.licenses' | translate }}</a>
            </div>
        </div>
    </div>
    <ng-template #footer>
        <div class="info-container" style="border-bottom:none">
            <div class="info-items-container">
                <div class="info-title">{{'iaa.app.hachraza.additionalInformationSite' | translate }}</div>
                <div class="item-container">
                    <img [ngClass]="{'link-icon icon-publications':true, 'en': (currentLanguage | async) === 'en'}" src="assets/atar-publications.svg" alt="Publications Icon" />
                    <a class="info-item" (click)="goTo('publications')">{{'iaa.app.hachraza.publications' | translate}}</a>
                </div>
                <div class="item-container">
                    <img class="link-icon" src="assets/atar-findings.svg" alt="Findings Icon" />
                    <a class="info-item" (click)="goTo('objects')"> {{'iaa.app.hachraza.findingsSite' | translate }}</a>
                </div>
                <div class="item-container">
                    <img class="link-icon" src="assets/atar-3d-models.svg" alt="Models Icon" />
                    <a class="info-item" (click)="goTo('photogrammetric_models')">{{'iaa.app.hachraza.models3D' | translate }}</a>
                </div>
                <div class="item-container">
                    <img class="link-icon" src="assets/atar-licenses.svg" alt="Licenses Icon" />
                    <a class="info-item" (click)="goTo('licenses')">{{'iaa.general.licenses' | translate }}</a>
                </div>
            </div>
        </div>
    </ng-template>
</app-entity-page>
